import {FormBuilderPage, FormViewerRouteParams} from '@/types';
import CenteredPageNumbers from '@/Components/TailwindUI/Pagination/CenteredPageNumbers';
import CenteredPageNumberLink from '@/Components/TailwindUI/Pagination/CenteredPageNumberLink';
import route from 'ziggy-js';
import {Link} from '@inertiajs/react';
import React, {ReactNode} from 'react';
import urlGenerator from '@/lib/urlGenerator';
import unhiddenPages from '@/lib/unhiddenPages';
import Arrow from '@/Components/Icons/Arrow';
import {Office} from "@/types/model";

interface Props {
    pageCount: number,
    page: FormBuilderPage,
    processing: boolean,
    data,
    submit,
    office: Office | null,
    latestPage: number,
    hiddenUrlParams: {string: string}[],
    pages: FormBuilderPage[],
    settings: { primaryColour: string, secondaryColour: string },
    mobileFooter?: string,
}

export default function FormViewerPagination({
                                                 pageCount,
                                                 page,
                                                 processing,
                                                 data,
                                                 submit,
                                                 office,
                                                 latestPage,
                                                 hiddenUrlParams,
                                                 pages,
                                                 settings,
                                             }: Props) {
    // We don't need to display a page count if there's only 1 page
    return (<CenteredPageNumbers processing={processing}
                                 showPrevious={page.number > 1}
                                 showSubmit={page.number == pageCount} data={data} submit={submit}
                                 renderRightButton={() => nextPageButton(processing, (page.number == pageCount), settings, page.number > 1)}
                                 renderLeftButton={() => previousPageButton(processing, (page.number > 1), page.number, page.form_id, office?.id, hiddenUrlParams, pages)}
                                 showLeftButton={page.number > 1}
    >
        {unhiddenPages(pages, data).map((p, i) => {
            const routeParams = urlGenerator(page.form_id, p.number, hiddenUrlParams);
            if (office) {
                routeParams['office'] = office.id;
            }
            return (<CenteredPageNumberLink key={p.id}
                                            processing={processing}
                                            active={page.number == p.number}
                                            disabled={(p.number) > page.number}
                                            href={(p.number) > latestPage ? '#' : route('form-viewer.show', routeParams)}
                                            settings={settings}
                                            realPageNumber={p.number}
            >{i + 1}</CenteredPageNumberLink>);
        })}
    </CenteredPageNumbers>);
}

export function nextPageButton(processing, showSubmit, settings, showLeft) {

    return (
        <button
            type="submit"
            data-cy="submit"
            disabled={processing}
            className={`inline-flex justify-center md:justify-start items-center border-transparent text-[${settings.secondaryColour}] py-3 px-3 text-sm font-medium hover:border-gray-300 bg-[${settings.primaryColour}] rounded w-full md:w-auto ${showLeft ? 'ml-2 md:ml-0' : ''}`}
        >
            Next
            <Arrow className={`ml-1 rotate-180 h-3 w-3 text-[${settings.secondaryColour}] stroke-[${settings.secondaryColour}]`} aria-hidden="true"/>
        </button>);
}

function previousPageButton(processing, show, pageNumber, formId, officeId, hiddenUrlParams, pages) {

    const currentPageIndex = pages.findIndex(p => p.number == pageNumber);
    const previousPageNumber = currentPageIndex > 0 ? pages[currentPageIndex - 1].number : 1;
    const routeParams: FormViewerRouteParams = urlGenerator(formId, previousPageNumber, hiddenUrlParams);
    if (officeId) {
        routeParams['office'] = officeId;
    }
    if (show) {
        return (<Link
            href={route('form-viewer.show', routeParams)}
            data-cy="previous"
            disabled={processing}
            className={`inline-flex items-center border-transparent text-[#131313] py-3 px-3 text-sm font-medium hover:border-gray-300 bg-gray-100 rounded w-full justify-center md:w-auto mr-2 md:mr-0`}
        >
            <Arrow className="mr-1 h-3 w-3 stroke-[#131313]" aria-hidden="true"/>
            Previous
        </Link>);
    } else {
        return null;
    }
}
